import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export const fallbackLng = ['en'];
const availableLanguages = ['en', 'tr'];

i18n.use(Backend)
    .use(LanguageDetector) // detect user language
    .use(initReactI18next) // pass the i18n instance to react-i18next.
    .init({
        fallbackLng, // fallback language is english.
        detection: {
            checkWhitelist: true, // options for language detection
        },
        debug: false,
        whitelist: availableLanguages,
        interpolation: {
            escapeValue: false, // no need for react. it escapes by default
        },
    }).then(r => {
    document.documentElement.lang = i18n.language;
});
export default i18n;
